module.exports = __webpack_public_path__ + "static/media/diez_gonzalez.81f9fea7.jpg";